import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BookWithADietitian() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="22739" id="即刻开始你的听力进化" className="dark bg-background text-foreground relative w-full h-[400px] flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618423/img/abstract_emerald_3d.png)] bg-cover bg-center" />

      {}
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/85 to-green-600/90" />

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-6 text-center max-w-3xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="font-sans text-4xl md:text-5xl font-bold text-white mb-6 tracking-tight">
          听不懂的英语，在这里都能听懂
        </h2>
        <p className="font-sans text-lg md:text-xl text-white/95 mb-8 max-w-2xl mx-auto leading-relaxed">
          AI逐句精听 + 智能记忆系统，让你的听力真正实现质的飞跃。加入听力通，让每一句英语都清晰入耳。
        </p>
        <div className="flex justify-center">
          <Button asChild size="lg" className="bg-white text-emerald-600 hover:bg-white/95 border-none font-bold tracking-wider py-6 px-10 text-lg rounded-2xl shadow-2xl transition-transform hover:scale-105">
            <Link to="/DownloadCenterPage">立即免费下载</Link>
          </Button>
        </div>
      </div>
    </section>;
}